module.exports = "/src/views/player/oressale/assets/images/ore_coal.png";